import { faEnvelope } from "@fortawesome/pro-solid-svg-icons";
import { useState } from "react";

import { T } from "@repo/transifex";
import { Button } from "~/components";
import {
  useSalesReportCombined,
  useSendEmailReportCombined
} from "~/hooks/queries/reportsCombined";

import { DialogSendReportEmail } from "./DialogSendReportEmail";

export const SendReportCombinedButton = ({
  dateSeconds
}: {
  dateSeconds?: string;
}) => {
  const [open, setOpen] = useState(false);

  const { data, status: reportStatus } = useSalesReportCombined(
    Number(dateSeconds || 0)
  );

  const {
    mutate: sendReport,
    status,
    reset
  } = useSendEmailReportCombined(Number(dateSeconds || 0));

  if (reportStatus === "error") return null;

  return (
    <>
      <Button
        className="w-full"
        icon={faEnvelope}
        loading={reportStatus === "pending"}
        onClick={() => {
          setOpen(true);
        }}
        size="large"
        variant="primary-light"
      >
        <T _str="Send report" />
      </Button>

      {data?.reports?.length ? (
        <DialogSendReportEmail
          onOutsideClick={() => {
            setOpen(false);
          }}
          onClose={() => {
            setOpen(false);
            reset();
          }}
          onSubmit={(email) => {
            sendReport({ email });
          }}
          status={status}
          open={open}
        />
      ) : null}
    </>
  );
};
